import {Negotiation} from "@/modules/diplomacy/entity";
import type {Relation} from "typeorm";
import {ChildEntity, ManyToOne} from "typeorm";
import {StaffMember} from "@/modules/staff/entity";

@ChildEntity()
export class StaffNegotiation extends Negotiation {
  @ManyToOne(() => StaffMember, r => r.negotiations)
  declare target: Relation<StaffMember>;

  async init(): Promise<void> {
    await super.init();
    await this.load('target');

    return;
  }
}
